export const DetailedInformationTemplate = {
  id: '',
  key: '',
  parentKey: '',
  label: '',
  data: '',
  organization: '',
  role: '',
  departmentCalendars: []
};
